<lms-modal #modalGroupsSelector size="small">
  <div class="gl-popup__title">{{ 'groups.bulk.changeGroupTitle' | translate }}</div>
  <div class="gl-popup__close" (click)="modalGroupsSelector.close()">
    <span class="glicon-close"></span>
  </div>
  <div
    *ngIf="total === 1"
    class="gl-popup__text margin-top-gap margin-bottom-half"
    [innerHtml]="'groups.bulk.changeGroupTextSingle' | translate : { students: total }"
  ></div>
  <div
    *ngIf="total > 1"
    class="gl-popup__text margin-top-gap margin-bottom-half"
    [innerHtml]="'groups.bulk.changeGroupText' | translate : { students: total }"
  ></div>
  <div class="gl-forms-new">
    <lms-select-dropdown
      [label]="'groups.bulk.groupName' | translate : { students: total }"
      [disabled]="!groupsList.length"
      [items]="groupsList"
      [selectedItem]="selectedGroup"
      (change)="selectGroup($event)"
    ></lms-select-dropdown>
  </div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="modalGroupsSelector.close()">
    </gl-button>
    <gl-button
      color-primary
      [text]="'groups.bulk.changeAction' | translate"
      [disabled]="!selectedGroup"
      (onClick)="confirmGroup()"
    >
    </gl-button>
  </div>
</lms-modal>
